import { Col, Row, Table } from "reactstrap";
import SimpleBar from "simplebar-react";
import PositionItemRow from "./PositionItemRow";
import React, { useCallback, useEffect, useRef } from "react";
import { Badge } from "@mantine/core";

const PositionItemsTable = ({
    items = [],
    itemsSelectedIds = [],
    itemsPosition = [],
    onRowSelectionChange,
}) => {
    const itemsTable = items.filter(item => itemsSelectedIds.includes(item.value));

    console.log('items position', itemsPosition)

    useEffect(() => {
        // Al montar, inicializar rowsRef con los valores existentes
        itemsPosition.forEach(ip => {
            rowsRef.current[ip.item_group_id] = { 
                item_group_id: ip.item_group_id, 
                quantity: ip.quantity 
            };
        });
    }, []); // solo al montar

    const rowsRef = useRef({});
    const initializedRef = useRef(false);

    // Efecto 1: inicializar desde itemsPosition cuando lleguen los datos (solo una vez)
    useEffect(() => {
        if (itemsPosition.length > 0 && !initializedRef.current) {
            itemsPosition.forEach(ip => {
                rowsRef.current[ip.item_group_id] = {
                    item_group_id: ip.item_group_id,
                    quantity: ip.quantity
                };
            });
            initializedRef.current = true;
            onRowSelectionChange(Object.values(rowsRef.current));
        }
    }, [itemsPosition]);

    // Efecto 2: sincronizar cuando cambia la selección, pero SOLO si ya inicializamos
    useEffect(() => {
        // Si aún no inicializamos y hay itemsPosition esperando, no hacer nada todavía
        if (!initializedRef.current && itemsPosition.length > 0) return;

        const currentIds = new Set(itemsSelectedIds);

        Object.keys(rowsRef.current).forEach(id => {
            if (!currentIds.has(id)) {
                delete rowsRef.current[id];
            }
        });

        itemsTable.forEach(item => {
            if (!rowsRef.current[item.value]) {
                rowsRef.current[item.value] = { item_group_id: item.value, quantity: 1 };
            }
        });

        onRowSelectionChange(Object.values(rowsRef.current));
    }, [itemsSelectedIds]);

    const handleRowChange = useCallback((itemId, quantity) => {
        rowsRef.current[itemId] = { item_group_id: itemId, quantity };
        onRowSelectionChange(Object.values(rowsRef.current));
    }, [onRowSelectionChange]);

    return (
        <React.Fragment>
            <Row className="mt-3">
                <Col>
                    <div className="d-flex align-items-start gap-2 mb-2">
                        <Badge color="blue" radius="md" size="lg">
                            Paso 2
                        </Badge>
                        <div>
                            <h5 className="my-0">Configuración de Cantidades por Cargo</h5>
                            <p>
                                Ajuste la cantidad requerida para los EPP seleccionados
                            </p>
                        </div>
                    </div>
                    <div
                        className="table-wrapper border"
                        style={{
                            maxHeight: "300px",
                            overflowY: "auto"
                        }}
                        >
                        <Table bordered hover striped className="table-sticky">
                            <thead>
                                <tr className="text-center align-middle">
                                    <th style={{ width: "200px" }}>Cantidad</th>
                                    <th>Nombre</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemsTable?.length > 0 ? (
                                    itemsTable.map((item, index) => {
                                        const existing = itemsPosition.find(ip => ip.item_group_id === item.value);
                                        return (
                                            <PositionItemRow
                                                key={item.value}
                                                keyId={item.value}
                                                item={item}
                                                initialQuantity={existing ? existing.quantity : 1}
                                                onRowSelectionChange={handleRowChange}
                                            />
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={2} className="text-center text-muted">
                                            No hay items disponibles
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default PositionItemsTable;